import { ChevronDown } from '@wix/wix-ui-icons-common/on-stage';
import { TextFieldTheme } from '@wix/wix-ui-tpa/cssVars';
import classNames from 'classnames';
import React, { useCallback, useMemo } from 'react';
import { useConfig } from '../../contexts/config-context';
import { useId } from '../../hooks/use-id';
import { classes, st } from './autocomplete-wut.cssVars.st.css';
import { OptionFactory } from './wut/WixUiCoreComponents/components/CoreDropdownOption';
import { CoreInputWithOptions } from './wut/WixUiCoreComponents/components/CoreInputWithOptons';
import { FloatingInputWithOptions } from './wut/WixUiCoreComponents/components/FloatingInputWithOptions';
const ARROW_DOWN = /*#__PURE__*/ React.createElement("span", {
    className: classes.suffix
}, /*#__PURE__*/ React.createElement(ChevronDown, {
    width: 24,
    height: 24,
    className: classes.arrowIcon
}));
const Prefix = ({ children })=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: classes.prefix
    }, children);
};
export const createOption = (option)=>OptionFactory.create(option);
export const AutocompleteWUT = ({ id, className, value, options, disabled, placeholder, error, showArrow, initialSelectedId, prefix, onInitialSelectedOptionsSet, filterPredicate, onSelect, onManualInput, onChange, onBlur, onFocus, ariaDescribedBy, theme = TextFieldTheme.Box, useFloatingUI = false })=>{
    const { isRTL: rtl } = useConfig();
    const inputProps = useMemo(()=>{
        return {
            id,
            value: value ?? '',
            error,
            placeholder,
            disabled,
            suffix: showArrow ? ARROW_DOWN : undefined,
            prefix: prefix ? /*#__PURE__*/ React.createElement(Prefix, null, prefix) : undefined,
            onChange,
            onBlur,
            onFocus,
            'aria-autocomplete': 'both',
            'aria-describedby': ariaDescribedBy
        };
    }, [
        id,
        value,
        error,
        placeholder,
        disabled,
        showArrow,
        prefix,
        onChange,
        onBlur,
        onFocus,
        ariaDescribedBy
    ]);
    const dropdownId = useId();
    const handleContentMouseDown = useCallback((e)=>{
        e.preventDefault(); // Prevent input blur from stopping click event
    }, []);
    const handleInitialSelectedOptionsSet = useCallback((selectedOptions)=>{
        onInitialSelectedOptionsSet?.(selectedOptions[0]);
    }, [
        onInitialSelectedOptionsSet
    ]);
    const rootClassName = st(classes.root, {
        disabled,
        error,
        hasPrefix: Boolean(prefix),
        hasSuffix: showArrow,
        rtl,
        theme
    }, classes.override, classNames(className, classes.theme, {
        [classes.rtl]: rtl
    }));
    if (useFloatingUI) {
        return /*#__PURE__*/ React.createElement(FloatingInputWithOptions, {
            id: dropdownId,
            className: rootClassName,
            inputProps: inputProps,
            options: options,
            filterPredicate: filterPredicate,
            onSelect: onSelect,
            onManualInput: onManualInput
        });
    }
    return /*#__PURE__*/ React.createElement(CoreInputWithOptions, {
        id: dropdownId,
        className: rootClassName,
        inputProps: inputProps,
        options: options,
        initialSelectedIds: initialSelectedId ? [
            initialSelectedId
        ] : undefined,
        onInitialSelectedOptionsSet: handleInitialSelectedOptionsSet,
        filterPredicate: filterPredicate,
        highlightMatches: false,
        allowReselect: true,
        onSelect: onSelect,
        onManualInput: onManualInput,
        onContentMouseDown: handleContentMouseDown
    });
};

//# sourceMappingURL=autocomplete-wut.js.map